var exports = {
  "o1": "xa15a2ab7--e801b1--actions",
};

module.exports = exports;
